import React, { useEffect, useState } from 'react';
import { tenantAPI } from '../api/client';
import { apiError } from '../lib/host';
import './Layout.css';

/** The member's profile stored in this organization's own database. */
export default function ProfileCard({ tenantName }) {
  const [profile, setProfile] = useState({ display_name: '', title: '' });
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    tenantAPI.profile()
      .then((res) => setProfile({ display_name: res.data.display_name || '', title: res.data.title || '' }))
      .catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await tenantAPI.saveProfile(profile);
      setMsg('Saved');
    } catch (err) {
      setMsg(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="tcx-panel">
      <h3>Your profile in {tenantName}</h3>
      <p className="tcx-muted" style={{ marginBottom: 12 }}>Visible only inside this organization.</p>
      <form className="tcx-row" onSubmit={save}>
        <div className="form-group">
          <label>Display name</label>
          <input className="tcx-input" value={profile.display_name}
            onChange={(e) => { setProfile({ ...profile, display_name: e.target.value }); setMsg(''); }} />
        </div>
        <div className="form-group">
          <label>Job title</label>
          <input className="tcx-input" value={profile.title}
            onChange={(e) => { setProfile({ ...profile, title: e.target.value }); setMsg(''); }} />
        </div>
        <button className="tcx-btn" disabled={busy}>Save</button>
        {msg && <span className="tcx-muted">{msg}</span>}
      </form>
    </section>
  );
}
